export const DoorIcon = `
<svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.725279 2.03845L7.72528 0.0384521L9 0.999976V19L7.72528 19.9615L0.725279 17.9615L0 17V2.99998L0.725279 2.03845ZM2 3.75428V16.2457L7 17.6742V11.5H5.5V9.49998H7V2.32571L2 3.75428Z" fill="#111111"/>
<path d="M14 3.99998H11V1.99998H16V18H11V16H14V3.99998Z" fill="#111111"/>
</svg>
`;

export const DrawerIcon = `
<svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 10C11 10.5523 10.5523 11 10 11C9.44771 11 9 10.5523 9 10C9 9.44772 9.44771 9 10 9C10.5523 9 11 9.44772 11 10Z" fill="#111111"/>
<path d="M10 5C10.5523 5 11 4.55229 11 4C11 3.44772 10.5523 3 10 3C9.44771 3 9 3.44772 9 4C9 4.55229 9.44771 5 10 5Z" fill="#111111"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20 0V2H19V15L17 15V14H3V15L1 15L1 2H0V0H20ZM17 12V8H3L3 12H17ZM17 6V2L3 2V6H17Z" fill="#111111"/>
</svg>
  `;

export const OrientationIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="m14.1289 2.1387 7.7782 7.7782L9.8863 21.9376 2.108 14.1595 14.1289 2.1387zm0 2.8284-9.1924 9.1924 4.9498 4.9497 9.1924-9.1924-4.9498-4.9497z" fill="#111"/>
  <path d="m2 6.4316 2.4545 2.5 2.4546-2.5H5.2515C5.3108 5.08 6.6448 3.75 8 3.75v-1.5c-2.164 0-4.2006 2.0132-4.2492 4.1816H2zm20 11.1368-2.4545-2.5-2.4546 2.5h1.6576C18.6892 18.9201 17.3553 20.25 16 20.25v1.5c2.164 0 4.2006-2.0132 4.2492-4.1816H22z" fill="#111"/>
</svg>
`;
